import styled, { css } from 'styled-components';
import { fontFamily } from '../../styles/_variables';
import { respondTo } from '../../styles/_respondTo';

export const Wrapper = styled.div`
  display: flex;
  position: relative;
  border-radius: 11px;
  overflow: hidden;
  //border: solid 1px #FF7828;
  border: solid 1px #fdf2eb;
  padding: 2px;
  height: 48px;
  max-width: ${({ maxW = 'auto' }) => maxW};
  width: ${({ width = 'auto' }) => width};
  ${respondTo.mobile`
    max-width: auto;
  `}
`;

export const TabItem = styled.div`
  flex: 1;
  font-family: ${fontFamily.primary};
  font-size: 14px;
  font-weight: bold;
  letter-spacing: -0.23px;
  text-align: center;
  width: ${({ w = 155 }) => w}px;
  //padding: 0 22px;
  color: ${({ active }) => (!active ? '#d6d6d6' : '#ffffff')};
  background-color: ${({ active }) => (active ? '#FF7828' : '#ffffff')};
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  cursor: pointer;
  transition: 0.3s ease all;
  ${({ active }) =>
    !active &&
    css`
      box-shadow: inset -1px 0 0 #fdf2eb;
    `};
  ${respondTo.mobile`
    max-width: auto;
    white-space: inherit;
  `}
  span {
    min-width: 111px;
  }
  &:first-child {
    border-radius: 8px 0 0 8px;
  }

  &:last-child {
    border-radius: 0 8px 8px 0;
    box-shadow: none !important;
  }
`;
